import { useTranslation } from 'react-i18next';

import { StatusMessage } from '../../agentViewState';
import { useCyclingMessage } from './useCyclingMessage';

const THINKING_MESSAGE_COUNT = 15;

type AgentLoadingStateProps = {
  statusMessages: Array<StatusMessage>;
};

export const AgentLoadingState = ({ statusMessages }: AgentLoadingStateProps) => {
  const thinkingMessages = useThinkingMessages();
  const cyclingMessage = useCyclingMessage(thinkingMessages);

  const lastMessage = statusMessages[statusMessages.length - 1];
  const showCyclingMessage = !lastMessage || lastMessage.status === 'done';

  return (
    <div className="flex flex-col gap-3 p-3">
      {statusMessages.map((msg, i) => (
        <p
          key={i}
          className={`text-sm ${
            msg.status === 'loading'
              ? 'animate-fade-slide-shimmer bg-linear-to-r from-gray-500 from-40% via-gray-300 via-50% to-gray-500 to-60% bg-size-[200%_100%] bg-clip-text text-transparent'
              : 'animate-fadeSlideIn text-gray-500'
          }`}
        >
          {msg.text}
        </p>
      ))}
      {showCyclingMessage && (
        <p
          key={cyclingMessage}
          className="animate-fade-slide-shimmer bg-linear-to-r from-gray-500 from-40% via-gray-300 via-50% to-gray-500 to-60% bg-size-[200%_100%] bg-clip-text text-sm text-transparent"
        >
          {cyclingMessage}
        </p>
      )}
    </div>
  );
};

// t('webedi:sidebar.agents.loading.thinking_0')
// t('webedi:sidebar.agents.loading.thinking_1')
// t('webedi:sidebar.agents.loading.thinking_2')
// t('webedi:sidebar.agents.loading.thinking_3')
// t('webedi:sidebar.agents.loading.thinking_4')
// t('webedi:sidebar.agents.loading.thinking_5')
// t('webedi:sidebar.agents.loading.thinking_6')
// t('webedi:sidebar.agents.loading.thinking_7')
// t('webedi:sidebar.agents.loading.thinking_8')
// t('webedi:sidebar.agents.loading.thinking_9')
// t('webedi:sidebar.agents.loading.thinking_10')
// t('webedi:sidebar.agents.loading.thinking_11')
// t('webedi:sidebar.agents.loading.thinking_12')
// t('webedi:sidebar.agents.loading.thinking_13')
// t('webedi:sidebar.agents.loading.thinking_14')
const useThinkingMessages = () => {
  const { t } = useTranslation();

  return Array.from({ length: THINKING_MESSAGE_COUNT }, (_, i) => t(`webedi:sidebar.agents.loading.thinking_${i}`));
};
